import React, { useState, useEffect } from 'react';
import axios from 'axios';

export default function Users() {
  const [users, setUsers] = useState([]);
  const [newUsername, setNewUsername] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [currPw, setCurrPw] = useState('');
  const [newPw, setNewPw] = useState('');
  const [err, setErr] = useState('');
  const [msg, setMsg] = useState('');
  const [pwErr, setPwErr] = useState('');
  const [pwMsg, setPwMsg] = useState('');
  const [loading, setLoading] = useState(true);

  const load = () => {
    setLoading(true);
    axios.get('/api/admin/users')
      .then(r => setUsers(r.data))
      .finally(() => setLoading(false));
  };

  useEffect(load, []);

  const add = async () => {
    if (!newUsername.trim() || !newPassword) { setErr('Username and password required'); return; }
    if (newPassword.length < 12) { setErr('Password must be at least 12 characters'); return; }
    setErr(''); setMsg('');
    try {
      const r = await axios.post('/api/admin/users', { username: newUsername.trim(), password: newPassword });
      setUsers(prev => [...prev, r.data]);
      setNewUsername(''); setNewPassword('');
      setMsg('User created.');
    } catch (e) { setErr(e.response?.data?.error || 'Failed to create user'); }
  };

  const remove = async (id, username) => {
    if (!window.confirm(`Delete user "${username}"? This cannot be undone.`)) return;
    setErr(''); setMsg('');
    try {
      await axios.delete(`/api/admin/users/${id}`);
      setUsers(prev => prev.filter(u => u.id !== id));
      setMsg('User deleted.');
    } catch (e) { setErr(e.response?.data?.error || 'Failed to delete user'); }
  };

  const changePw = async () => {
    if (!currPw || !newPw) { setPwErr('Both fields required'); return; }
    if (newPw.length < 12) { setPwErr('New password must be at least 12 characters'); return; }
    setPwErr(''); setPwMsg('');
    try {
      await axios.post('/api/admin/change-password', { current_password: currPw, new_password: newPw });
      setCurrPw(''); setNewPw('');
      setPwMsg('Password changed successfully.');
    } catch (e) { setPwErr(e.response?.data?.error || 'Failed to change password'); }
  };

  return (
    <div>
      <div className="admin-card">
        <h2>Admin Users</h2>
        <p style={{ fontSize: 14, color: 'var(--text-light)', marginBottom: 16 }}>
          Add or remove admin accounts. You cannot delete your own account.
        </p>
        <div className="admin-input-row">
          <input className="admin-input" value={newUsername} onChange={e => setNewUsername(e.target.value)}
            placeholder="Username" style={{ flex: 1 }} />
          <input className="admin-input" type="password" value={newPassword} onChange={e => setNewPassword(e.target.value)}
            placeholder="Password (12+ chars)" style={{ flex: 1 }} />
          <button className="btn-primary" onClick={add}>Add User</button>
        </div>
        {err && <div className="field-error" style={{ marginBottom: 8 }}>{err}</div>}
        {msg && <div style={{ color: 'var(--success)', fontSize: 14, marginBottom: 8 }}>{msg}</div>}

        {loading ? <p>Loading...</p> : (
          <table className="admin-table">
            <thead><tr><th>Username</th><th>Action</th></tr></thead>
            <tbody>
              {users.map(u => (
                <tr key={u.id}>
                  <td>{u.username}</td>
                  <td><button className="btn-danger" onClick={() => remove(u.id, u.username)}>Delete</button></td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      <div className="admin-card">
        <h2>Change My Password</h2>
        <div className="field-group">
          <label className="field-label">Current Password</label>
          <input className="field-input" type="password" value={currPw}
            onChange={e => setCurrPw(e.target.value)} placeholder="Current password" />
        </div>
        <div className="field-group">
          <label className="field-label">New Password</label>
          <input className="field-input" type="password" value={newPw}
            onChange={e => setNewPw(e.target.value)} placeholder="New password (12+ chars)" />
        </div>
        {pwErr && <div className="field-error" style={{ marginBottom: 8 }}>{pwErr}</div>}
        {pwMsg && <div style={{ color: 'var(--success)', fontSize: 14, marginBottom: 8 }}>{pwMsg}</div>}
        <button className="btn-primary" onClick={changePw}>Change Password</button>
      </div>
    </div>
  );
}
